import React from 'react'


class Draggable extends React.Component {


    onDragEnter = (e) => {
        // console.log("HEE")
        // e.preventDefault()

        // if (!this.state.isDragging) {
        // console.log("DragOVER")
        e.preventDefault()
        e.stopPropagation()

        // this.setState({ isDraggingOver: false })

        this.props.dragOver(this.props.id)
        // }

        // setIsOnDragEnter(true)
    }


    onDragStart = (e) => {
        // console.log(e)
        // e.dataTransfer.setDragImage(this.draggableItem,0,0);
        // console.log(this.draggableItem)
        // e.dataTransfer.setData('id', this.props.id)
        this.props.dragStarted(e, this.props.id, this.props.index)
        
        // this.setState({ isDragging: true })
        // this.dragIndicator.addClass('hide')

        // console.log(this.props.id)

        // this.props.cloneRow(row.current)
    }

    onDrop = (e) => {
        // console.log("DROP")
        // e.preventDefault()
        let id = e.dataTransfer.getData('id', this.props.id)
        this.props.onDrop(id)

        // console.log("DROP")
        // console.log(id)
    }

    onDragEnd = (e) => {
        this.props.dragEnd(e)

        // this.dragIndicator.removeClass('hide')
    }

    render() {
        if (this.props.children) {
            let children = []
            if (Array.isArray(this.props.children)) {
                children = this.props.children.map(function (child, i) {
                    if (child.type != null) {

                        return React.cloneElement(child,
                            { key: i, onDragStart: this.onDragStart, onDrag: this.props.onDrag }
                        )

                    }
                    return
                }, this);
            } else {
                children = React.cloneElement(this.props.children,
                    { onDragStart: this.onDragStart, onDrag: this.props.onDrag }
                )

            }

            return (
                <div className="draggable-component" ref={el => this.draggableItem = el} onDrop={e => this.onDrop(e, 'complete')} onDragEnter={e => this.onDragEnter(e)} onDragEnd={e => this.onDragEnd(e)} >

                    {children}

                    {/* <div className={"drag-indicator"} draggable onDragStart={e => this.onDragStart(e)} onDrag={e => this.props.onDrag(e)} >
                        
                    </div> */}

                </div>
            )
        } else {
            return <div></div>
        }
    }

}

export default Draggable
